import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CallData, TotalData } from '../../../call-center/call-center-reservation';

@Injectable({
  providedIn: 'root'
})
export class CallPatientRepoService {

  constructor() { }

  PatientCode: number;
  SpecialityCode: number;
  DocId: number;
  CallData: CallData;
  totalPatientData: TotalData;

  activateNewPatReservation: BehaviorSubject<number> = new BehaviorSubject<number>(6743);
  activateNewPatReservation$ = this.activateNewPatReservation.asObservable();
  setNewPatReservation(value: number) {
    this.activateNewPatReservation.next(value);
  }

  saveCallCenterReservation: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  saveCallCenterReservation$ = this.saveCallCenterReservation.asObservable();
  callCenterReservation(value: boolean) {
    this.saveCallCenterReservation.next(value);
  }


  resetData() {
    this.PatientCode = 0;
    this.SpecialityCode = 0;
    this.DocId = 0;
    this.CallData = null;
    this.totalPatientData = null;
  }
}
